import TabInput from './TabInput';

export default TabInput;
